import React from "react";
import { LoginContentWrapper } from "Components";
import { useLoginInfo } from "Hooks";
import ChangePasswordForm from "../../components/ChangePasswordForm/ChangePasswordForm";
import PasswordResetLayout from "../../components/PasswordResetLayout";

const ChangePassword = (): React.JSX.Element => {
  const { hasLoaded, isSSOLogin, isInFlight } = useLoginInfo();

  if (isInFlight)
    return (
      <PasswordResetLayout>
        <></>
      </PasswordResetLayout>
    );
  else if (hasLoaded && isSSOLogin)
    return (
      <PasswordResetLayout>
        <LoginContentWrapper
          title="Cannot change password"
          byline="Changing password is disabled while SSO is active"
        />
      </PasswordResetLayout>
    );

  return (
    <PasswordResetLayout>
      <ChangePasswordForm />
    </PasswordResetLayout>
  );
};

export default ChangePassword;
